export default "__VITE_ASSET__D7LeO8aN__"